module.exports = {"insurance_type":null,"annual_policy_premium_amount":null,"annual_policy_premium_paid_for":null,"coverage_description":null,"deductible_amount":null,"coverage_amount":null,"policy_number":null,"effective":null,"expiration":null}


//////////////////
// WEBPACK FOOTER
// ./src/components/my_deals/actions/insurance/resources/model.json
// module id = xUSe
// module chunks = 1